export default {
  fetchCareers({commit}, data) {
    commit('SET_CAREERS', data.careers)
  },
  addCareer({commit}, data) {
    commit('ADD_ITEM', data.career)
  },
  updateCareer({commit}, data) {
    commit('UPDATE_CAREER', data.career)
  },
  deleteCareer({commit}, data) {
    commit('REMOVE_ITEM', data.career)
  }
}
